import { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import AuthService from '../../services/AuthService';
import LoadingOverlay from '../../components/loading-overlay/LoadingOverlay';
import logCaughtException from '../../helpers/logCaughtException';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      logged: false,
      login: true,
      redirect: this.props.location.state && this.props.location.state.from ? this.props.location.state.from : '/',
    };
  }

  componentDidMount() {
    // React ignores whatever this lifecycle returns, so the promise has to be
    // terminated here or a rejection becomes an unhandled one.
    this.performLogin().catch(logCaughtException);
  }

  async performLogin() {
    this.setState({ login: true });
    const loginResult = await AuthService.login();
    let logged = false;
    if (loginResult) {
      logged = true;
    }
    setTimeout(() => {
      this.setState({ logged, login: false });
      this.props.setIsAuthenticated(logged);
    }, 2000);
  }

  render() {
    if (this.state.login) {
      return (
        <div className="loading-overlay">
          <LoadingOverlay
            className="loading"
            active
            spinner
            fadeSpeed={100}
            text="Cargando..."
          />
        </div>
      );
    }

    if (this.state.logged) {
      return <Redirect to={this.state.redirect} />;
    }

    return (
      <div>
        Redirecting...
        <Redirect to="external-login" />
      </div>
    );
  }
}

Login.propTypes = {
  location: PropTypes.object,
  setIsAuthenticated: PropTypes.func,
};

export default Login;
